import { render, staticRenderFns } from "./TryFrameworkContent.vue?vue&type=template&id=140493af&scoped=true&"
import script from "./TryFrameworkContent.vue?vue&type=script&lang=js&"
export * from "./TryFrameworkContent.vue?vue&type=script&lang=js&"
import style0 from "./TryFrameworkContent.vue?vue&type=style&index=0&id=140493af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140493af",
  null
  
)

export default component.exports